import React from 'react';
import Button from '@mui/material/Button';
import setSearchReferencesDataAction from '../../redux/actions/searchReferenceActions/actionSearchReferencesData';
import setScroolPositionAction from '../../redux/actions/showReferenceActions/actionScrollPosition';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from "react-router-dom";

export default function SearchButton(props) {

    // const [referencesData, setReferencesData] = useState("");
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const searchRefStateData = useSelector(state => state.searchRefState)
    const navigate = useNavigate();

    const handleClick = async () => {
        dispatch(setScroolPositionAction(0))
        await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/searchRef/references/search?searchCountry=` +
            `${searchRefStateData.searchCountry.country}&searchProvince=${searchRefStateData.searchProvince.province}` +
            `&searchCity=${searchRefStateData.searchCity.city}&searchTitle=${searchRefStateData.searchTitle}` +
            `&searchDateFrom=${searchRefStateData.searchDateFrom}&searchDateTo=${searchRefStateData.searchDateTo}&searchCreator=${searchRefStateData.searchCreator}` +
            `&searchProductSystem=${searchRefStateData.searchProductSystem}&searchProduct=${searchRefStateData.searchProduct}` +
            `&searchZip=${searchRefStateData.searchZip.zip}&searchFOE=${searchRefStateData.searchFOE.foe}` +
            `&searchCreateDateFrom=${searchRefStateData.searchCreateDateFrom}&searchCreateDateTill=${searchRefStateData.searchCreateDateTill}` +
            `&searchContestRelease=${searchRefStateData.searchContestRelease}&language=${localStorage.getItem('language')}&firm=${searchRefStateData.searchFirm.nr}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                 Accept: 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('jwToken')}`
            }
        }).then(response => response.json())
            .then(data => {
                dispatch(setSearchReferencesDataAction(data))
                navigate("/viewRef");
            })
            .catch((error) => {
                console.error('Error:', error);
                navigate('login')
            });
    }

    return (
        <div>
            <Button onClick={handleClick} style={{ width: 300, backgroundColor: 'rgba(19, 174, 236, 0.54)', marginBottom: 10 }} variant="contained" color="primary" size="large">
                {t("search_ref.search_button")}
            </Button>
        </div >
    )

}